export default class OfferCreator {
    public static getPriceForDiscount(fullprice: number, discount: number, onsuccess: (price: string) => void): void {
        const url = '/?view=offercreator&action=discountinfo';

        const params = {
            fullprice: fullprice,
            discount: discount
        };

        $.get(url, params, (r) => {
            onsuccess(r.price);
        });
	}

    public static getDiscountForPrice(fullprice: number, price: number, onsuccess: (discount: number) => void): void {
        const url = '/?view=offercreator&action=discountinfo';

        const params = {
            fullprice: fullprice,
            price: price
        };

        $.get(url, params, (r) => {
            onsuccess(r.discount);
        });
	}
}
